export const STICKY_HEADER_BAR_DATA_ATTRIBUTE = 'data-sticky-headerbar-scom';
